export type exceptionType = 'cancelled_by_professional' | 'cancelled_by_patient' | 'professional_unavailability'

interface RecurrencyException {
  exceptionDate: string
  exceptionType: exceptionType
}

export interface Reservation {
  uuid: string
  startDate: Date
  creationDate: Date
  patientUsername: string
  patientFullName: string
  patientCellphone: string
  professionalUsername: string
  professionalFullName: string
  professionalCellphone: string
  professionalPictureUrl: string
  recurrence: ReservationRecurrence
  recurrencyExceptions: RecurrencyException[]
}

export enum ReservationRecurrence {
  'WEEKLY' = 'Semanal',
  'NON_RECURRENT' = 'Avulsa'
}